export default {
    titleMessageModal: 'Nouveau message',
    placeholder: 'Texte du message',
    btnSend: 'Envoyer',
    btnCancel: 'Annuler'
}